// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"728821bd","706":"9338e118","783":"9c2d57fb","890":"f93ca673","943":"49e97fca","956":"f2d4a890","981":"a435c0d1"}[chunkId] + ".chunk.js";
};